/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List services
 */

export const listServicesQueryPerPageMax = 100;

export const listServicesQueryStateDefault = `ACTIVE`;
export const listServicesQuerySortKeyDefault = `serviceId`;

export const ListServicesQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listServicesQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce
    .string()
    .optional()
    .describe("Case-insensitive substring search across Service code or name"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listServicesQueryStateDefault)
    .describe("Service state filter"),
  compositionKind: zod
    .enum(["SIMPLE", "COMPOSITE"])
    .optional()
    .describe("Service composition-kind filter"),
  supplyStatus: zod
    .enum(["SUPPLIED", "UNSUPPLIED"])
    .optional()
    .describe("Service supply-status filter"),
  functionId: zod.uuid().optional().describe("Assigned Service Function id"),
  billingUnit: zod
    .enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"])
    .optional()
    .describe("Service billing-unit filter"),
  sortKey: zod
    .enum(["serviceId", "code", "name"])
    .default(listServicesQuerySortKeyDefault)
    .describe("Service sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
});

export const listServicesResponseItemsItemComponentsItemOneOneQuantityExclusiveMin = 0;

export const listServicesResponseItemsItemComponentsItemTwoOneQuantityExclusiveMin = 0;

export const listServicesResponseMetaTotalMin = 0;

export const ListServicesResponse = zod.object({
  items: zod.array(
    zod.object({
      serviceId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
      kind: zod.enum(["SERVICE"]),
      state: zod.enum(["ACTIVE", "DELETED"]),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      deletedAt: zod.iso.datetime({offset: true}).nullable(),
      code: zod.string(),
      name: zod.string(),
      internalDescription: zod.string(),
      priceProtected: zod.boolean(),
      billingUnit: zod
        .unknown()
        .and(zod.unknown())
        .and(zod.unknown())
        .and(zod.unknown())
        .and(zod.unknown())
        .and(zod.unknown())
        .and(
          zod.object({
            code: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
            name: zod.string(),
            symbol: zod.string(),
          }),
        )
        .describe("Fixed Service billing-unit entry."),
      descriptionEntries: zod.array(
        zod.object({
          language: zod.enum(["ES", "EN", "FR"]).describe("Supported business language."),
          text: zod.string(),
        }),
      ),
      functionIds: zod.array(zod.uuid().describe("Service Function identity.")),
      compositionKind: zod.enum(["SIMPLE", "COMPOSITE"]),
      supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
      components: zod.array(
        zod.union([
          zod
            .object({
              componentCatalogItemId: zod
                .uuid()
                .describe("Identity shared by Material and Service Catalog Items."),
              state: zod.enum(["ACTIVE", "DELETED"]),
              code: zod.string(),
              name: zod.string(),
              quantity: zod
                .number()
                .gt(listServicesResponseItemsItemComponentsItemOneOneQuantityExclusiveMin)
                .describe(
                  "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
                ),
              supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
            })
            .and(
              zod.object({
                kind: zod.enum(["MATERIAL"]),
                unitOfMeasure: zod
                  .unknown()
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(
                    zod.object({
                      code: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
                      name: zod.string(),
                      symbol: zod.string(),
                    }),
                  )
                  .describe("Fixed physical Material unit entry."),
              }),
            )
            .and(
              zod.object({
                kind: zod.enum(["MATERIAL"]),
              }),
            ),
          zod
            .object({
              componentCatalogItemId: zod
                .uuid()
                .describe("Identity shared by Material and Service Catalog Items."),
              state: zod.enum(["ACTIVE", "DELETED"]),
              code: zod.string(),
              name: zod.string(),
              quantity: zod
                .number()
                .gt(listServicesResponseItemsItemComponentsItemTwoOneQuantityExclusiveMin)
                .describe(
                  "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
                ),
              supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
            })
            .and(
              zod.object({
                kind: zod.enum(["SERVICE"]),
                billingUnit: zod
                  .unknown()
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(zod.unknown())
                  .and(
                    zod.object({
                      code: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
                      name: zod.string(),
                      symbol: zod.string(),
                    }),
                  )
                  .describe("Fixed Service billing-unit entry."),
              }),
            )
            .and(
              zod.object({
                kind: zod.enum(["SERVICE"]),
              }),
            ),
        ]),
      ),
      notes: zod.array(
        zod.object({
          noteId: zod.int().describe("Note identity."),
          createdAt: zod.iso.datetime({offset: true}),
          updatedAt: zod.iso.datetime({offset: true}),
          title: zod.string(),
          content: zod.string(),
        }),
      ),
    }),
  ),
  meta: zod
    .object({
      total: zod.int().min(listServicesResponseMetaTotalMin).describe("Total matching items."),
      page: zod.int().min(1).describe("Current 1-indexed page."),
      perPage: zod.int().min(1).describe("Requested items per page."),
    })
    .describe("Metadata for a paginated collection."),
});

/**
 * @summary Create service
 */
export const createServiceBodyTwoComponentsItemQuantityExclusiveMin = 0;

export const CreateServiceBody = zod.union([
  zod.object({
    compositionKind: zod.enum(["SIMPLE"]),
    code: zod.string(),
    name: zod.string(),
    internalDescription: zod.string(),
    priceProtected: zod.boolean(),
    billingUnit: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
    initialSupplierId: zod.uuid().describe("Supplier identity."),
  }),
  zod.object({
    compositionKind: zod.enum(["COMPOSITE"]),
    code: zod.string(),
    name: zod.string(),
    internalDescription: zod.string(),
    priceProtected: zod.boolean(),
    billingUnit: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
    components: zod
      .array(
        zod.object({
          componentCatalogItemId: zod
            .uuid()
            .describe("Identity shared by Material and Service Catalog Items."),
          quantity: zod
            .number()
            .gt(createServiceBodyTwoComponentsItemQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
        }),
      )
      .min(1),
  }),
]);

export const CreateServiceResponse = zod
  .uuid()
  .describe("Identity shared by Material and Service Catalog Items.");

/**
 * @summary Get service
 */
export const getServiceQueryIncludeDeletedDefault = false;

export const GetServiceQueryParams = zod.object({
  includeDeleted: zod.boolean().default(getServiceQueryIncludeDeletedDefault),
});

export const getServiceResponseComponentsItemOneOneQuantityExclusiveMin = 0;

export const getServiceResponseComponentsItemTwoOneQuantityExclusiveMin = 0;

export const GetServiceResponse = zod.object({
  serviceId: zod.uuid().describe("Identity shared by Material and Service Catalog Items."),
  kind: zod.enum(["SERVICE"]),
  state: zod.enum(["ACTIVE", "DELETED"]),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  code: zod.string(),
  name: zod.string(),
  internalDescription: zod.string(),
  priceProtected: zod.boolean(),
  billingUnit: zod
    .unknown()
    .and(zod.unknown())
    .and(zod.unknown())
    .and(zod.unknown())
    .and(zod.unknown())
    .and(zod.unknown())
    .and(
      zod.object({
        code: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
        name: zod.string(),
        symbol: zod.string(),
      }),
    )
    .describe("Fixed Service billing-unit entry."),
  descriptionEntries: zod.array(
    zod.object({
      language: zod.enum(["ES", "EN", "FR"]).describe("Supported business language."),
      text: zod.string(),
    }),
  ),
  functionIds: zod.array(zod.uuid().describe("Service Function identity.")),
  compositionKind: zod.enum(["SIMPLE", "COMPOSITE"]),
  supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
  components: zod.array(
    zod.union([
      zod
        .object({
          componentCatalogItemId: zod
            .uuid()
            .describe("Identity shared by Material and Service Catalog Items."),
          state: zod.enum(["ACTIVE", "DELETED"]),
          code: zod.string(),
          name: zod.string(),
          quantity: zod
            .number()
            .gt(getServiceResponseComponentsItemOneOneQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
          supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
        })
        .and(
          zod.object({
            kind: zod.enum(["MATERIAL"]),
            unitOfMeasure: zod
              .unknown()
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(
                zod.object({
                  code: zod.enum(["KG", "M", "L", "UNIT", "M2", "M3"]),
                  name: zod.string(),
                  symbol: zod.string(),
                }),
              )
              .describe("Fixed physical Material unit entry."),
          }),
        )
        .and(
          zod.object({
            kind: zod.enum(["MATERIAL"]),
          }),
        ),
      zod
        .object({
          componentCatalogItemId: zod
            .uuid()
            .describe("Identity shared by Material and Service Catalog Items."),
          state: zod.enum(["ACTIVE", "DELETED"]),
          code: zod.string(),
          name: zod.string(),
          quantity: zod
            .number()
            .gt(getServiceResponseComponentsItemTwoOneQuantityExclusiveMin)
            .describe(
              "Positive quantity interpreted using the referenced Catalog Item unit or billing unit.",
            ),
          supplyStatus: zod.enum(["SUPPLIED", "UNSUPPLIED"]),
        })
        .and(
          zod.object({
            kind: zod.enum(["SERVICE"]),
            billingUnit: zod
              .unknown()
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(zod.unknown())
              .and(
                zod.object({
                  code: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
                  name: zod.string(),
                  symbol: zod.string(),
                }),
              )
              .describe("Fixed Service billing-unit entry."),
          }),
        )
        .and(
          zod.object({
            kind: zod.enum(["SERVICE"]),
          }),
        ),
    ]),
  ),
  notes: zod.array(
    zod.object({
      noteId: zod.int().describe("Note identity."),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      title: zod.string(),
      content: zod.string(),
    }),
  ),
});

/**
 * @summary Update service
 */
export const UpdateServiceBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  internalDescription: zod.string(),
  billingUnit: zod.enum(["HOUR", "DAY", "JOB", "UNIT", "M", "M2"]),
});

export const UpdateServiceResponse = zod.void();

/**
 * @summary Delete service
 */
export const DeleteServiceResponse = zod.void();

/**
 * @summary Restore service
 */
export const RestoreServiceResponse = zod.void();
